/* Keep literal searches relevant and prevent stale autocomplete responses. */
(function () {
  'use strict';
  function terms(value) {
    return value.replace(/["*\\]/g, '').trim().split(/\s+/).filter(Boolean);
  }
  function query(value) {
    return terms(value).map(function (word) { return '(title:"' + word + '" OR tag:"' + word + '")'; }).join(' AND ');
  }
  function searchURL(form, value) {
    var url = new URL(form.action, location.origin);
    url.searchParams.set('q', query(value));
    url.searchParams.set('type', 'product');
    url.searchParams.set('sort_by', 'relevance');
    return url;
  }
  var states = new WeakMap();
  window.textualSearch = function (input, box) {
    var state = states.get(input);
    if (!state) { state = { version: 0 }; states.set(input, state); }
    clearTimeout(state.timer);
    if (state.controller) state.controller.abort();
    var version = ++state.version, value = input.value.trim();
    box.replaceChildren();
    box.style.display = 'none';
    if (value.length < 2) return;
    state.timer = setTimeout(async function () {
      var controller = new AbortController();
      state.controller = controller;
      var timeout = setTimeout(function () { controller.abort(); }, 10000);
      var url = new URL(input.form.action.replace(/\/$/, '') + '/suggest.json', location.origin);
      url.searchParams.set('q', value);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '10');
      function current() { return version === state.version && input.value.trim() === value; }
      function note(text, href) {
        var node = document.createElement(href ? 'a' : 'div');
        node.className = 'note'; node.textContent = text;
        if (href) node.href = href;
        box.appendChild(node);
      }
      try {
        var response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        var data = await response.json();
        if (!current()) return;
        // Predictive search can suggest unrelated designs. Require each typed
        // word to occur in the product's searchable text, allowing word prefixes.
        var words = terms(value.toLocaleLowerCase());
        var products = data.resources.results.products.filter(function (product) {
          var body = new DOMParser().parseFromString(product.body || '', 'text/html');
          var haystack = [product.title, product.type, (product.tags || []).join(' '), body.body.textContent].join(' ').toLocaleLowerCase();
          return words.every(function (word) { return haystack.indexOf(word) !== -1; });
        }).slice(0, 5);
        products.forEach(function (product) {
          var link = document.createElement('a'); link.href = product.url;
          var wrap = document.createElement('div'); wrap.className = 'img';
          if (product.image) {
            var img = document.createElement('img');
            var src = new URL(product.image, location.origin); src.searchParams.set('width', '160');
            img.src = src.href; img.alt = ''; wrap.appendChild(img);
          }
          var title = document.createElement('div'); title.className = 'search-title'; title.textContent = product.title;
          var price = document.createElement('div'); price.className = 'serach-price';
          var money = document.createElement('span'); money.className = 'money';
          money.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency', currency: (window.Shopify.currency && window.Shopify.currency.active) || 'USD'
          }).format(Number(product.price));
          price.appendChild(money); link.append(wrap, title, price); box.appendChild(link);
        });
        if (!products.length) note('No matching products found. Try another keyword.');
        note('See all results for “' + value + '”', searchURL(input.form, value).href);
      } catch (error) {
        if (!current()) return;
        note('Search all products for “' + value + '”', searchURL(input.form, value).href);
      } finally {
        clearTimeout(timeout);
        if (current() && document.activeElement === input) box.style.display = 'block';
      }
    }, 200);
  };
  document.querySelectorAll('form[role="search"]').forEach(function (form) {
    var input = form.querySelector('[name="q"]');
    if (!input) return;
    input.value = terms(input.value).join(' ');
    form.addEventListener('formdata', function (event) {
      event.formData.set('q', query(input.value));
      event.formData.set('type', 'product');
      event.formData.set('sort_by', 'relevance');
    });
  });
}());
